export default __webpack_public_path__ + "static/media/iconInfo.17aeb2b1.svg";